import createIcon from '../../createIcon';

/**
 * @component @name Diversity1
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,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)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Diversity1 = createIcon('Diversity1', [
  [
    'path',
    {
      d: 'M4 16.5C5.10457 16.5 6 15.6046 6 14.5C6 13.3954 5.10457 12.5 4 12.5C2.89543 12.5 2 13.3954 2 14.5C2 15.6046 2.89543 16.5 4 16.5Z',
      key: '12tvet',
    },
  ],
  [
    'path',
    {
      d: 'M1.22 18.08C0.48 18.4 0 19.12 0 19.93V21.5H4.5V19.89C4.5 19.06 4.73 18.28 5.13 17.6C4.76 17.54 4.39 17.5 4 17.5C3.01 17.5 2.07 17.71 1.22 18.08Z',
      key: '1ahes9',
    },
  ],
  [
    'path',
    {
      d: 'M20 16.5C21.1046 16.5 22 15.6046 22 14.5C22 13.3954 21.1046 12.5 20 12.5C18.8954 12.5 18 13.3954 18 14.5C18 15.6046 18.8954 16.5 20 16.5Z',
      key: 'jf18u8',
    },
  ],
  [
    'path',
    {
      d: 'M22.78 18.08C21.93 17.71 20.99 17.5 20 17.5C19.61 17.5 19.24 17.54 18.87 17.6C19.27 18.28 19.5 19.06 19.5 19.89V21.5H24V19.93C24 19.12 23.52 18.4 22.78 18.08Z',
      key: 'zr57jw',
    },
  ],
  [
    'path',
    {
      d: 'M16.24 17.15C15.07 16.63 13.63 16.25 12 16.25C10.37 16.25 8.93 16.64 7.76 17.15C6.68 17.63 6 18.71 6 19.89V21.5H18V19.89C18 18.71 17.32 17.63 16.24 17.15Z',
      key: 'wyjyz5',
    },
  ],
  [
    'path',
    {
      d: 'M9 12.5C9 14.16 10.34 15.5 12 15.5C13.66 15.5 15 14.16 15 12.5C15 10.84 13.66 9.5 12 9.5C10.34 9.5 9 10.84 9 12.5Z',
      key: 'hwkuaa',
    },
  ],
  [
    'path',
    {
      d: 'M2.48 11.36C2.17 10.6 2 9.86 2 9.1C2 6.52 4.02 4.5 6.6 4.5C9.28 4.5 10.42 6.24 12 8.09C13.57 6.26 14.7 4.5 17.4 4.5C19.98 4.5 22 6.52 22 9.1C22 9.86 21.83 10.6 21.52 11.36C22.17 11.67 22.7 12.18 23.05 12.8C23.65 11.6 24 10.38 24 9.1C24 5.4 21.1 2.5 17.4 2.5C15.31 2.5 13.31 3.47 12 5.01C10.69 3.47 8.69 2.5 6.6 2.5C2.9 2.5 0 5.4 0 9.1C0 10.38 0.35 11.6 0.96 12.8C1.31 12.18 1.84 11.67 2.48 11.36Z',
      key: 's3skjm',
    },
  ],
]);

export default Diversity1;
